module.exports = __webpack_public_path__ + "img/Flag_of_Saint_Vincent_and_the_Grenadines.5b7543e0.svg";